module.exports = __webpack_public_path__ + "img/parser.f015923e.svg";